const GaoKaoLayout = r => require(['@/v3/modules/report/views/gaokao/components/GaoKaoLayout'], r)
const ExamList = r => require(['@/v3/modules/report/views/gaokao/index'], r) // 考试列表
const LevelType = r => require(['@/v3/modules/report/views/gaokao/levelType'], r)
const LevelTypeOld = r => require(['@/v3/modules/report/views/gaokao/oldpage/levelType'], r)
const ChooseExam = r => require(['@/v3/modules/report/views/gaokao/chooseExam'], r)
const ChooseExamOld = r => require(['@/v3/modules/report/views/gaokao/oldpage/chooseExam'], r)
const ChooseExamNew = r => require(['@/v3/modules/report/views/gaokao/chooseExamNew'], r)
const ChooseExam2Old = r => require(['@/v3/modules/report/views/gaokao/oldpage/chooseExam2'], r)
const SetLevel = r => require(['@/v3/modules/report/views/gaokao/setLevel'], r)
const SetLevelOld = r => require(['@/v3/modules/report/views/gaokao/oldpage/setLevel'], r)
const StudentSubmit = r => require(['@/v3/modules/report/views/gaokao/student_submit'], r)

const ReportLayout = r => require(['@/v3/modules/report/views/gaokao/report/layout'], r)
const ReportSummaryBasic = r => require(['@/v3/modules/report/views/gaokao/report/summary/basic'], r)
const ReportSummaryScoreSection = r => require(['@/v3/modules/report/views/gaokao/report/summary/scoreSection'], r)
const ReportSummaryTranscript = r => require(['@/v3/modules/report/views/gaokao/report/summary/transcript'], r)
const ReportSummaryExamBasic = r => require(['@/v3/modules/report/views/gaokao/report/examBasic'], r)

const ReportSubjectBasic = r => require(['@/v3/modules/report/views/gaokao/report/subject/basic'], r)
const ReportSubjectScoreSection = r => require(['@/v3/modules/report/views/gaokao/report/subject/scoreSection'], r)

const ReportLikeBasic = r => require(['@/v3/modules/report/views/gaokao/report/like/basic'], r)
const ReportLikeLevelAnalysis = r => require(['@/v3/modules/report/views/gaokao/report/like/levelAnalysis'], r)
const ReportLikeScoreSection = r => require(['@/v3/modules/report/views/gaokao/report/like/scoreSection'], r)
const ReportLikeTranscript = r => require(['@/v3/modules/report/views/gaokao/report/like/transcript'], r)

const ReportWenkeBasic = r => require(['@/v3/modules/report/views/gaokao/report/wenke/basic'], r)
const ReportWenkeLevelAnalysis = r => require(['@/v3/modules/report/views/gaokao/report/wenke/levelAnalysis'], r)
const ReportWenkeScoreSection = r => require(['@/v3/modules/report/views/gaokao/report/wenke/scoreSection'], r)
const ReportWenkeTranscript = r => require(['@/v3/modules/report/views/gaokao/report/wenke/transcript'], r)

export default [
  {
    path: '/exam/gaokao',
    name: 'exam-gaokao',
    component: ExamList,
    meta: { auth: ['Exam-Gaokao', 'New-Gaokao-Report'], keepAlive: true, checkAuth: true }
  },
  {
    path: '/exam/gaokao/leveltype_old',
    name: 'LevelTypeOld',
    component: LevelTypeOld,
    meta: { auth: ['Exam-Gaokao', 'New-Gaokao-Report', 'Region-Exam-Gaokao', 'City-Exam-Gaokao'], keepAlive: true }
  },
  {
    path: '/exam/gaokao/chooseExam_old',
    name: 'ChooseExamOld',
    component: ChooseExamOld,
    meta: { auth: ['Exam-Gaokao', 'New-Gaokao-Report', 'Region-Exam-Gaokao', 'City-Exam-Gaokao'], keepAlive: true }
  },
  {
    path: '/exam/gaokao/chooseExam2_old',
    name: 'ChooseExam2Old',
    component: ChooseExam2Old,
    meta: { auth: ['Exam-Gaokao', 'New-Gaokao-Report', 'Region-Exam-Gaokao', 'City-Exam-Gaokao'], keepAlive: true }
  },
  {
    path: '/exam/gaokao/setLevel_old',
    name: 'SetLevelOld',
    component: SetLevelOld,
    meta: { auth: ['Exam-Gaokao', 'New-Gaokao-Report', 'Region-Exam-Gaokao', 'City-Exam-Gaokao'], keepAlive: true }
  },
  {
    path: '/exam/gaokao/student_submit',
    name: 'StudentSubmit',
    component: StudentSubmit,
    meta: { auth: ['Exam-Gaokao', 'New-Gaokao-Report'], keepAlive: true }
  },
  {
    path: '/exam/gaokao/report/:id',
    component: ReportLayout,
    name: 'Exam-Gaokao-Report',
    meta: { auth: ['Exam-Gaokao', 'New-Gaokao-Report'], keepAlive: true },
    // redirect: "/exam/gaokao/report/:id/summary",
    children: [
      // 汇总报表
      {
        path: '/exam/gaokao/report/:id/summary',
        meta: { auth: ['Exam-Gaokao-Report-Summary', 'New-Gaokao-Report'], keepAlive: true },
        component: () =>
          import('@/v3/modules/report/views/gaokao/report/summary/layout.vue'),
        name: 'Exam-Gaokao-Report-Summary',
        redirect: '/exam/gaokao/report/:id/summary/basic',
        children: [
          {
            path: '/exam/gaokao/report/:id/summary/basic',
            meta: { auth: ['Exam-Gaokao-Report-Summary', 'New-Gaokao-Report'], keepAlive: true },
            component: ReportSummaryBasic,
            name: 'gaokao-summaryReport-basic'
          },
          {
            path: '/exam/gaokao/report/:id/summary/scoreSection',
            meta: { auth: ['Exam-Gaokao-Report-Summary', 'New-Gaokao-Report'], keepAlive: true },
            component: ReportSummaryScoreSection,
            name: 'gaokao-summaryReport-scoreSection'
          },
          {
            path: '/exam/gaokao/report/:id/summary/transcript',
            meta: { auth: ['Exam-Gaokao-Report-Summary', 'New-Gaokao-Report'], keepAlive: true },
            component: ReportSummaryTranscript,
            name: 'gaokao-summaryReport-transcript'
          }
        ]
      },

      // 主科报表
      {
        path: '/exam/gaokao/report/:id/subject',
        meta: { auth: ['Exam-Gaokao-Report-Subject', 'New-Gaokao-Report'], keepAlive: true },
        component: () =>
          import('@/v3/modules/report/views/gaokao/report/subject/layout.vue'),
        name: 'Exam-Gaokao-Report-Subject',
        redirect: '/exam/gaokao/report/:id/subject/basic',
        children: [
          {
            path: '/exam/gaokao/report/:id/subject/basic',
            meta: { auth: ['Exam-Gaokao-Report-Subject', 'New-Gaokao-Report'], keepAlive: true },
            component: ReportSubjectBasic,
            name: 'gaokao-Subject-Report-basic'
          },
          {
            path: '/exam/gaokao/report/:id/subject/scoreSection',
            meta: { auth: ['Exam-Gaokao-Report-Subject', 'New-Gaokao-Report'], keepAlive: true },
            component: ReportSubjectScoreSection,
            name: 'gaokao-Subject-Report-scoreSection'
          }
        ]
      },

      // 理科报表
      {
        path: '/exam/gaokao/report/:id/like',
        meta: { auth: ['Exam-Gaokao-Report-like', 'New-Gaokao-Report'], keepAlive: true },
        component: () => import('@/v3/modules/report/views/gaokao/report/like/layout.vue'),
        name: 'Exam-Gaokao-Report-like',
        // redirect: "/exam/gaokao/report/:id/like/basic",
        children: [
          {
            path: '/exam/gaokao/report/:id/like/basic',
            meta: { auth: ['Exam-Gaokao-Report-like', 'New-Gaokao-Report'], keepAlive: true },
            component: ReportLikeBasic,
            name: 'gaokao-likeReport-basic'
          },
          {
            path: '/exam/gaokao/report/:id/like/levelAnalysis',
            meta: { auth: ['Exam-Gaokao-Report-like', 'New-Gaokao-Report'], keepAlive: true },
            component: ReportLikeLevelAnalysis,
            name: 'gaokao-likeReport-levelAnalysis'
          },
          {
            path: '/exam/gaokao/report/:id/like/scoreSection',
            meta: { auth: ['Exam-Gaokao-Report-like', 'New-Gaokao-Report'], keepAlive: true },
            component: ReportLikeScoreSection,
            name: 'gaokao-likeReport-scoreSection'
          },
          {
            path: '/exam/gaokao/report/:id/like/transcript',
            meta: { auth: ['Exam-Gaokao-Report-like', 'New-Gaokao-Report'], keepAlive: true },
            component: ReportLikeTranscript,
            name: 'gaokao-likeReport-transcript'
          },
          {
            path: '/exam/gaokao/report/:id/like/examBasic',
            component: ReportSummaryExamBasic,
            name: 'gaokao-summaryReport-examBasic'
          }
        ]
      },

      // 文科报表
      {
        path: '/exam/gaokao/report/:id/wenke',
        meta: { auth: ['Exam-Gaokao-Report-wenke', 'New-Gaokao-Report'], keepAlive: true },
        component: () => import('@/v3/modules/report/views/gaokao/report/wenke/layout.vue'),
        name: 'Exam-Gaokao-Report-wenke',
        // redirect: "/exam/gaokao/report/:id/wenke/basic",
        children: [
          {
            path: '/exam/gaokao/report/:id/wenke/basic',
            meta: { auth: ['Exam-Gaokao-Report-wenke', 'New-Gaokao-Report'], keepAlive: true },
            component: ReportWenkeBasic,
            name: 'gaokao-wenkeReport-basic'
          },
          {
            path: '/exam/gaokao/report/:id/wenke/levelAnalysis',
            meta: { auth: ['Exam-Gaokao-Report-wenke', 'New-Gaokao-Report'], keepAlive: true },
            component: ReportWenkeLevelAnalysis,
            name: 'gaokao-wenkeReport-levelAnalysis'
          },
          {
            path: '/exam/gaokao/report/:id/wenke/scoreSection',
            meta: { auth: ['Exam-Gaokao-Report-wenke', 'New-Gaokao-Report'], keepAlive: true },
            component: ReportWenkeScoreSection,
            name: 'gaokao-wenkeReport-scoreSection'
          },
          {
            path: '/exam/gaokao/report/:id/wenke/transcript',
            meta: { auth: ['Exam-Gaokao-Report-wenke', 'New-Gaokao-Report'], keepAlive: true },
            component: ReportWenkeTranscript,
            name: 'gaokao-wenkeReport-transcript'
          },
          {
            path: '/exam/gaokao/report/:id/wenke/examBasic',
            component: ReportSummaryExamBasic,
            name: 'gaokao-summaryReport-examBasic'
          }
        ]
      }
    ]
  },
  {
    component: GaoKaoLayout,
    name: 'GaoKaoLayout',
    path: '/exam/gaokao/layout',
    redirect: '/exam/gaokao/levelType',
    meta: { auth: ['Exam-Gaokao', 'New-Gaokao-Report', 'Region-Exam-Gaokao', 'City-Exam-Gaokao'], keepAlive: true },
    children: [
      {
        path: '/exam/gaokao/levelType',
        name: 'LevelType',
        component: LevelType,
        meta: { auth: ['Exam-Gaokao', 'New-Gaokao-Report', 'Region-Exam-Gaokao', 'City-Exam-Gaokao'], keepAlive: true }
      },
      {
        path: '/exam/gaokao/chooseExam',
        name: 'ChooseExam',
        component: ChooseExam,
        meta: { auth: ['Exam-Gaokao', 'New-Gaokao-Report', 'Region-Exam-Gaokao', 'City-Exam-Gaokao'], keepAlive: true }
      },
      {
        path: '/exam/gaokao/chooseExamNew',
        name: 'ChooseExamNew',
        component: ChooseExamNew,
        meta: { auth: ['Exam-Gaokao', 'New-Gaokao-Report', 'Region-Exam-Gaokao', 'City-Exam-Gaokao'], keepAlive: true }
      },
      {
        path: '/exam/gaokao/setLevel',
        name: 'SetLevel',
        component: SetLevel,
        meta: { auth: ['Exam-Gaokao', 'New-Gaokao-Report', 'Region-Exam-Gaokao', 'City-Exam-Gaokao'], keepAlive: true }
      }
    ]
  }
]
